<template>
  <div class="counter-wraper-by-level counter" :class="{ 'has-hover': hovered }">   
    <div class="level level-novice">{{ validatedNoviceCount }}</div>
    <div class="level level-apprentice">{{ validatedApprenticeCount }}</div>
    <div class="level level-professional">{{ validatedProfessionalCount }}</div>
    <div class="level level-coach">{{ validatedCoachCount }}</div>
    <div class="level level-master">{{ validatedMasterCount }}</div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  count_of_apprentice: {
    type: Number,
    default: 0,
  },
  count_of_professional: {
    type: Number,
    default: 0,
  },
  count_of_coach: {
    type: Number,
    default: 0,
  },
  count_of_master: {
    type: Number,
    default: 0,
  },
  count_of_novice: {
    type: Number,
    default: 0,
  },
  hovered: {
    type: Boolean,
    default: false,
  },
});

const validatedApprenticeCount = computed(() => {
  return props.count_of_apprentice >= 0 ? props.count_of_apprentice : 0;
});
const validatedProfessionalCount = computed(() => {
  return props.count_of_professional >= 0 ? props.count_of_professional : 0;
});
const validatedCoachCount = computed(() => {
  return props.count_of_coach >= 0 ? props.count_of_coach : 0;
});
const validatedMasterCount = computed(() => {
  return props.count_of_master >= 0 ? props.count_of_master : 0;
});
const validatedNoviceCount = computed(() => {
  return props.count_of_novice >= 0 ? props.count_of_novice : 0;
});
</script>


<style scoped>
.counter-wraper-by-level.counter {
  display: flex;
  column-gap: 3px;
  padding: 8px;
  border-radius: 8px;
  width: fit-content;
  transition: background-color 0.2s ease;
}
.counter-wraper-by-level.counter.has-hover:hover {
  background-color: #f2edff;
  cursor: pointer;
}
.counter-wraper-by-level .level {
  height: 44px;
  min-width: 44px;
  border: 1px solid;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.counter-wraper-by-level .level-apprentice {
  border-color: #E58700;
  background-color: #FFF5D3;
  color: #E58700;
}
.counter-wraper-by-level .level-professional {
  border-color: #00B813;
  background-color: #F3FFF9;
  color: #00B813;
}
.counter-wraper-by-level .level-coach {
  border-color: #00A3FF;
  background-color: #F2F6FF;
  color: #00A3FF;
}
.counter-wraper-by-level .level-master {
  border-color: #2E1EC1;
  background-color: #F1EFFF;
  color: #2E1EC1;
}
.counter-wraper-by-level .level-novice {
  border-color: #E53200;
  background-color: #FFD3D3;
  color: #E53200;
}
</style>